import { CupertinoPane } from 'cupertino-pane';
import { initProductForm } from "@theme/cart";
import EmblaCarousel from "embla-carousel";
import { addDotButtonAndClickHandlers } from "@theme/base";
import PhotoSwipeLightbox from "photoswipe-lightbox";
import PhotoSwipe from "photoswipe";

function initMobPanel() {
    // === 1. Product Description Toggle ===
    const textEl = document.querySelector('.product-detail .product-description');
    const btnEl = document.getElementById('toggleDescription');

    if (textEl && btnEl) {
        if (textEl.scrollHeight > textEl.clientHeight) {
            btnEl.style.display = 'block'; // Mostra il bottone solo se il testo effettivamente straborda
        }

        btnEl.addEventListener('click', () => {
            const isExpanded = textEl.classList.toggle('expanded');
            btnEl.classList.toggle('open', isExpanded);
            btnEl.textContent = isExpanded ? btnEl.dataset.less : btnEl.dataset.more;
        });
    }

    // === 2. Cupertino Bottom Sheet Pane ===
    const paneElement = document.querySelector('#cupertino-panel');
    const openBtn = document.getElementById('panel-open');

    if (paneElement) {
        let myPane = null;
        let isDismissedByUser = false;
        let skipNextBottomTransition = false;

        // Calcola l'altezza dinamicamente in base al contenuto
        const calculateBottomHeight = () => {
            // Opzione 1: Leggi da attributo data-bottom-height nell'HTML
            const dataHeight = paneElement.dataset.bottomHeight;
            if (dataHeight) {
                return parseInt(dataHeight, 10);
            }

            // Opzione 2: Calcola in base all'altezza di un elemento specifico interno
            const contentEl = paneElement.querySelector('.pane-preview-content');
            if (contentEl) {
                return contentEl.offsetHeight + 40; // +40 per padding/margini
            }

            // Opzione 3: Percentuale della viewport
            // return Math.round(window.innerHeight * 0.25); // 25% dell'altezza schermo

            // Fallback
            return 180;
        };

        let bottomHeight = calculateBottomHeight();

        const calculateTopHeight = () => {
            const headerHeight = parseInt(
                getComputedStyle(document.documentElement).getPropertyValue('--header-height') || '0',
                10
            );
            return window.innerHeight - headerHeight;
        };

        let topHeight = calculateTopHeight();

        // Crea un placeholder nascosto per tenere traccia della posizione originale della sidebar nel DOM desktop
        const placeholder = document.createElement('div');
        placeholder.style.display = 'none';
        paneElement.parentNode.insertBefore(placeholder, paneElement);

        const initCupertinoPane = () => {
            if (window.innerWidth < 768) {
                const root = document.documentElement;
                root.style.setProperty('--bottom-sheet-height', `${bottomHeight}px`);
                root.style.setProperty('--bottom-sheet-top-height', `${topHeight}px`);
                root.style.setProperty('--bottom-sheet-visible-height', `${bottomHeight}px`);
                void root.offsetHeight; // Forza repaint su iOS Safari

                if (!myPane && !isDismissedByUser) {
                    myPane = new CupertinoPane(paneElement, {
                        parentElement: 'body',
                        initialBreak: 'bottom',
                        breaks: {
                            top: { enabled: true, height: topHeight, bounce: true },
                            middle: { enabled: false },
                            bottom: { enabled: true, height: bottomHeight, bounce: true }
                        },
                        clickBottomOpen: false,
                        buttonDestroy: false,
                        fastSwipeClose: false,
                        preventOverScroll: true,
                        events: {
                            onDidPresent: () => {
                                document.body.classList.add('has-bottom-sheet');
                                document.documentElement.classList.add('has-bottom-sheet');
                                document.documentElement.style.setProperty('--bottom-sheet-visible-height', `${bottomHeight}px`);
                            },
                            onDismiss: () => {
                                document.documentElement.style.setProperty('--bottom-sheet-visible-height', '0px');
                                document.body.classList.remove('has-bottom-sheet');
                                document.documentElement.classList.remove('has-bottom-sheet');
                                openBtn?.classList.remove("close");
                                myPane = null;
                                isDismissedByUser = true; // Evita loop di riapertura automatica su scroll mobile
                            },
                            onTransitionEnd: () => {
                                if (myPane) {
                                    const currentBreak = myPane.currentBreak();
                                    const root = document.documentElement;
                                    if (currentBreak === 'bottom') {
                                        if (skipNextBottomTransition) {
                                            skipNextBottomTransition = false;
                                            return;
                                        }
                                        openBtn?.classList.remove("close");
                                        root.style.setProperty('--bottom-sheet-visible-height', `${bottomHeight}px`);
                                    } else if (currentBreak === 'top') {
                                        openBtn?.classList.add("close");
                                        root.style.setProperty('--bottom-sheet-visible-height', `${topHeight}px`);
                                    }
                                    void root.offsetHeight;
                                }
                            }
                        }
                    });
                    myPane.present();
                }
            } else {
                // Desktop: smantella il pannello mobile se attivo e ripristina SEMPRE l'elemento nella sidebar corretta
                if (myPane) {
                    myPane.destroy({ animate: false });
                    document.body.classList.remove('has-bottom-sheet');
                    document.documentElement.classList.remove('has-bottom-sheet');
                    openBtn?.classList.remove("close");
                    myPane = null;
                }
                // Rimuovi le variabili CSS quando si passa a desktop
                document.documentElement.style.setProperty('--bottom-sheet-visible-height', '0px');

                paneElement.removeAttribute("style");
                if (placeholder.parentNode && paneElement.parentNode !== placeholder.parentNode) {
                    placeholder.parentNode.insertBefore(paneElement, placeholder);
                }
            }
        };

        // ponytail: register BEFORE initCupertinoPane so our capture fires before Cupertino's
        if (openBtn) {
            window.addEventListener('click', (ev) => {
                if (window.innerWidth >= 768) return;
                if (!ev.target.closest('#panel-open')) return;

                ev.preventDefault();
                ev.stopPropagation();
                ev.stopImmediatePropagation();

                const form = document.querySelector('form[data-type="add-to-cart-form"]');
                const submitBtn = form?.querySelector('[type="submit"]');

                if (submitBtn.classList.contains('use-notify-me')) {
                    const modal = document.getElementById('klaviyo-bis-modal');
                    if (modal && modal.parentElement !== document.body) document.body.appendChild(modal);
                    modal?.showModal();
                } else if (!submitBtn?.disabled) {
                    form?.requestSubmit(submitBtn);
                } else {
                    // No variant → toggle panel
                    isDismissedByUser = false;
                    if (!myPane) initCupertinoPane();
                    if (myPane) {
                        const goTop = myPane.currentBreak() === 'bottom';
                        if (goTop) skipNextBottomTransition = true;
                        myPane.moveToBreak(goTop ? 'top' : 'bottom');
                        openBtn.classList.toggle('close', goTop);
                    }
                }
            }, true);
        }

        // Inizializzazione al caricamento
        initCupertinoPane();

        let lastWidth = window.innerWidth;
        window.addEventListener('resize', () => {
            if (window.innerWidth !== lastWidth) {
                lastWidth = window.innerWidth;
                topHeight = calculateTopHeight();
                const root = document.documentElement;
                root.style.setProperty('--bottom-sheet-height', `${bottomHeight}px`);
                root.style.setProperty('--bottom-sheet-top-height', `${topHeight}px`);
                root.style.setProperty('--bottom-sheet-visible-height', `${bottomHeight}px`);
                void root.offsetHeight; // Forza repaint su iOS Safari
                initCupertinoPane();
            }
        });

        if (openBtn) {
            // ponytail: sync text with submit button state
            const syncOpenBtnText = () => {
                const submitBtn = document.querySelector('form[data-type="add-to-cart-form"] [type="submit"]');
                if (!submitBtn) return;

                const textSpan = submitBtn.querySelector('.btn-text');
                const submitText = textSpan ? textSpan.textContent : submitBtn.textContent;
                openBtn.textContent = submitText;
            };

            document.addEventListener('variant-change', syncOpenBtnText);
        }
    }
}

function initPdp() {
  initMobPanel();
  initPhotoSwipe();
   document.querySelectorAll("form[data-type='add-to-cart-form']").forEach((form) => {
    initProductForm(form);
  });

  document.addEventListener('DOMContentLoaded',()=>{const b=document.querySelector('.header__breadcrumb');if(b){const p=document.querySelector('#cupertino-panel');if(p?.lastElementChild)p.insertBefore(b,p.lastElementChild);b.style.display='';}});
}

class ProductGallery extends HTMLElement {
  connectedCallback() {
    const viewportNode = this.querySelector(".embla__viewport");
    const dotsNode = this.querySelector(".embla__dots");

    if (viewportNode) {
      this.emblaApi = EmblaCarousel(viewportNode, {
        axis: "y",
        loop: false,
      });

      if (dotsNode) {
        dotsNode.innerHTML = "";
        addDotButtonAndClickHandlers(this.emblaApi, dotsNode);
      }
    }

    this.style.visibility = '';
  }

  disconnectedCallback() {
    this.emblaApi?.destroy();
  }
}

customElements.define("product-gallery", ProductGallery);


const rightArrowSVGString = `<svg width="24" height="24" aria-hidden="true" focusable="false"><use href="#arrow-right-alanui" /></svg>`;
const leftArrowSVGString = `<svg width="24" height="24" aria-hidden="true" focusable="false"><use href="#arrow-left-alanui" /></svg>`;
const closeSVGString = `<svg width="24" height="24" aria-hidden="true" focusable="false"><use href="#icon-close" /></svg>`;
function initPhotoSwipe() {
    const lightbox = new PhotoSwipeLightbox({
        gallery: ".product-images, #embla-mobile-pdp-gallery",
        children: "a.image-zoom",
        pswpModule: PhotoSwipe,
        initialZoomLevel: 'fit',
        secondaryZoomLevel: 1,
        maxZoomLevel: 1,        
        //showHideAnimationType: 'fade',
        counter: false,
        zoom: false,
        arrowPrevSVG: leftArrowSVGString,
        arrowNextSVG: rightArrowSVGString,
        closeSVG: closeSVGString,
        bgOpacity: 1,
        showHideAnimationType: 'fade'
    });

    lightbox.on('uiRegister', function() {
        lightbox.pswp.ui.registerElement({
            name: 'bulletsIndicator',
            className: 'pswp__bullets-indicator',
            appendTo: 'wrapper',
            onInit: (el, pswp) => {
                const bullets = [];
                let bullet;
                let span;
                let prevIndex = -1;

                for (let i = 0; i < pswp.getNumItems(); i++) {
                    bullet = document.createElement('div');
                    bullet.className = 'pswp__bullet';

                    span = document.createElement('span');
                    span.className = 'pswp__bullet__inner';
                    bullet.appendChild(span);

                    bullet.onclick = () => {
                    pswp.goTo(bullets.indexOf(bullet));
                    };
                    el.appendChild(bullet);
                    bullets.push(bullet);
                }

                pswp.on('change', (a,) => {
                    if (prevIndex >= 0) {
                    bullets[prevIndex].classList.remove('pswp__bullet--active');
                    }
                    bullets[pswp.currIndex].classList.add('pswp__bullet--active');
                    prevIndex = pswp.currIndex;
                });
            }
        });
    });

  lightbox.init();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initPdp, { once: true });
} else {
  initPdp();
}